/* eslint-disable no-use-before-define */
import React from 'react'
import Icons from './icons'
import { showModal, getConfig } from '../twd/all'

export default () => {
    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'

return <React.Fragment>
    <div className="container">
    <div className="row text-center prospect vertical-offset-sm">

        <div className="flex-xs-12 flex-md-6 auto-margin">
        <h2>Instant analysis of your portfolio</h2>
        <h3>View market data, performance reports, and income outlook of your bond portfolio holdings.</h3>
        </div>
    </div>

    <div className="row">
    <div className="card-group">
        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'blue-top' : 'purple-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.executive_summary}
                <h3 className="card-title">Executive<br/>summary</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Get a snapshot view of your complete portfolio, including:
                <ul>
                <li>Summary totals and averages for portfolio holdings</li>
                <li>Asset class and credit quality diversification</li>
                <li>Maturity and duration exposure</li>
                </ul>
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'executive_summary',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>


        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'blue-top' : 'purple-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.position_details}
                <h3 className="card-title">Position<br/>details</h3>
            </div>
            <div className="card-text vertical-offset-base">
            In-depth view on all fixed income positions in your portfolio, current evaluated pricing, and unrealized gain or loss calculations
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'position_details',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>

        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'blue-top' : 'purple-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.reinvestment_proceeds}
                <h3 className="card-title">Reinvestment<br/>proceeds</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Gain quick perspective on upcoming reinvestment proceeds (coupon payments, maturing principal, called bond proceeds) due from your holdings
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'reinvestment_proceeds',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>

        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'blue-top' : 'purple-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.coupon_cashflow}
                <h3 className="card-title">Coupon<br/>cash flow</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Easily review and analyze your portfolio’s income and forward-looking monthly cash flows based on:
            <ul>
            <li>Asset Class</li>
            <li>Distribution by taxable or tax-exempt positions</li>
            <li>Coupon payment date</li>
            </ul>
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'coupon_cashflow',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>

        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'orange-top' : 'yellow-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.credit_ratings_history}
                <h3 className="card-title">Credit ratings<br/>history</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Access current and historical credit rating history from Moody’s and S&P, along with credit watch and outlook expectations
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'credit_ratings_history',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>


        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'orange-top' : 'yellow-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.muni_position_attributes}
                <h3 className="card-title">Muni position<br/>attributes</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Acquire further insights on your municipal holdings with position analysis covering:
            <ul>
            <li>Type of Muni and Funding Purpose</li>
            <li>Holdings distribution by state</li>
            <li>Insurance and credit enhancements</li>
            </ul>
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'muni_position_attributes',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>


        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'orange-top' : 'yellow-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.corp_position_attributes}
                <h3 className="card-title">Corp position<br/>attributes</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Acquire further insights on your corporate holdings with position analysis covering:
            <ul>
            <li>Sector distribution</li>
            <li>Debt ranking distribution</li>
            </ul>
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'corp_position_attributes',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>


        <div className={"card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 " + (isBlue ? 'orange-top' : 'yellow-top')}>
        <div className="card-body">
            <div className="prospect text-center">
                {Icons.fdic_certificate_concentration}
                <h3 className="card-title">FDIC certificate #<br/>concentration</h3>
            </div>
            <div className="card-text vertical-offset-base">
            Understand your CD position concentration by individual FDIC Certificate Number
            </div>
        </div>
        <div className="card-footer text-center">
            <button className="btn-link"
                onClick={(e) => showModal({
                    view: 'portfolio-report-modal',
                    name: 'fdic_certificate_concentration',
                    source: e.target,
                })}
            >View example</button>
        </div>
        </div>
    </div>
    </div>

    <div className="row vertical-offset-xxxl" ></div>

    </div>
    </React.Fragment>
}
